import React, { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import "../../components/MultiRepCardLease";
import "../../styles/CoCBoxes.css";

export default function CoCBoxes({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const [SellerRep, setSellerRep] = useState("");
  const [BuyerRep, setBuyerRep] = useState("");
  const [sameTeam, setSameTeam] = useState("No");

  const handleSellerRep = (e) => {
    setSameTeam("No");
    if (e.target.value !== "IRepSeller") {
      setBuyerRep("IRepBuyer");
      setSellerRep(e.target.value);
    }
    setSellerRep(e.target.value);
  };

  const handleBuyerRep = (e) => {
    setSameTeam("No");
    if (e.target.value !== "IRepBuyer") {
      setSellerRep("IRepSeller");
      setBuyerRep(e.target.value);
    }
    setBuyerRep(e.target.value);
  };

  useEffect(() => {
    setProvince("ON");
  });

  let CoCData = ["Select Representation"];
  if (
    (SellerRep === "IRepSeller" && BuyerRep === "IRepBuyer") ||
    sameTeam === "Yes"
  ) {
    CoCData = ["2b"];
  } else if (SellerRep === "IRepSeller" && BuyerRep === "OtherExpBuyer") {
    CoCData = ["1a", "1a-3"];
  } else if (SellerRep === "IRepSeller" && BuyerRep === "OBBuyer") {
    CoCData = [
      "1a",
      "1a-1",
      "4a",
      "4a-1",
      "4b",
      `4b-1 or 4b-2 (4b-2 is typically
      used when the negotiated commission varies from what is posted on the MLS Listing)`,
    ];
  } else if (SellerRep === "IRepSeller" && BuyerRep === "SRPBuyer") {
    CoCData = ["1a", "1a-2"];
  } else if (SellerRep === "OtherExpSeller" && BuyerRep === "IRepBuyer") {
    CoCData = ["1a", "1a-3"];
  } else if (SellerRep === "OBSeller" && BuyerRep === "IRepBuyer") {
    CoCData = [
      "1a",
      "1a-1",
      "4a",
      "4a-1",
      "4b",
      `4b-1 or 4b-2 (4b-2 is typically
      used when the negotiated commission varies from what is posted on the MLS Listing)`,
    ];
  } else if (SellerRep === "SRPSeller" && BuyerRep === "IRepBuyer") {
    CoCData = [
      "3b (if using a remuneration clause) OR",
      "3a (if Buyer/Tenant is paying commission directly)",
    ];
  } else {
    CoCData = ["Select Representation"];
  }

  return (
    <div className="checklists flex flex-col w-full pt-5 pl-4 ">
      <div className="flex flex-col w-full pb-3 pt-3 items-center pr-4">
        <span>
          <strong>
            Form 320/324: Confirmation of Co-operation and Representation
            Checkbox Tool
          </strong>
          <br />
          <br />
          Select who is representing the Buyers/Tenants & Sellers/Landlords in
          the dropdowns and the appropriate checkboxes for that scenario will
          display in the section below. To see an example of Form 320, visit the{" "}
          <a href="/ON/common-forms" rel="noreferrer">
            Common Forms Section
          </a>
          <br />
        </span>
      </div>
      <div className="flex  flex-col items-left w-full pb-5">
        <ThemeProvider theme={theme}>
          <FormControl sx={{ mt: 2, minWidth: 330, maxWidth: 330 }}>
            <InputLabel size="small" className="select-default-label">
              Seller/Landlord Representation
            </InputLabel>
            <Select
              value={SellerRep}
              name="Seller Representation"
              label="Seller/Landlord Representation"
              onChange={handleSellerRep}
              size="small"
              sx={{ borderRadius: 20 }}
            >
              <MenuItem key={Math.random()} value="IRepSeller">
                I Represent the Seller/Landlord
              </MenuItem>
              <MenuItem key={Math.random()} value="OtherExpSeller">
                Different eXp Agent
              </MenuItem>
              <MenuItem key={Math.random()} value="OBSeller">
                Other Brokerage Agent
              </MenuItem>
              <MenuItem key={Math.random()} value="SRPSeller">
                Seller/Landlord is a SRP
              </MenuItem>
            </Select>
          </FormControl>
        </ThemeProvider>
        <ThemeProvider theme={theme}>
          <FormControl sx={{ mt: 2, minWidth: 330, maxWidth: 330 }}>
            <InputLabel size="small" className="select-default-label">
              Buyer/Tenant Representation
            </InputLabel>
            <Select
              value={BuyerRep}
              name="Buyer Representation"
              label="Buyer/Tenant Representation"
              onChange={handleBuyerRep}
              size="small"
              sx={{ borderRadius: 20 }}
            >
              <MenuItem key={Math.random()} value="IRepBuyer">
                I Represent the Buyer/Tenant
              </MenuItem>
              <MenuItem key={Math.random()} value="OtherExpBuyer">
                Different eXp Agent
              </MenuItem>
              <MenuItem key={Math.random()} value="OBBuyer">
                Other Brokerage Agent
              </MenuItem>
              <MenuItem key={Math.random()} value="SRPBuyer">
                Buyer/Tenant is a SRP
              </MenuItem>
            </Select>
          </FormControl>
        </ThemeProvider>
        {(SellerRep === "IRepSeller" && BuyerRep === "OtherExpBuyer") ||
        (SellerRep === "OtherExpSeller" && BuyerRep === "IRepBuyer") ? (
          <div className="mt-5">
            <div className="pr-5">
              Are both agents on the same team, and is the team lead named on
              both the Buyer/Tenant and Seller/Landlord Representation
              Agreements?
            </div>
            <ThemeProvider theme={theme}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="same-team-radio-buttons"
                  name="same-team-radio-buttons"
                  value={sameTeam}
                  defaultValue="No"
                >
                  <FormControlLabel
                    value="Yes"
                    control={
                      <Radio size="small" onClick={() => setSameTeam("Yes")} />
                    }
                    label="Yes"
                  />
                  <FormControlLabel
                    value="No"
                    control={
                      <Radio size="small" onClick={() => setSameTeam("No")} />
                    }
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </ThemeProvider>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="checklist-card checklist-card-modern">
        <div className="flex flex-wrap checklist-card-header">
          <div>FORM 320/324 Checkboxes</div>
        </div>
        <div className="clause-card-content">
          <ul>
            {(SellerRep === "IRepSeller" && BuyerRep === "IRepBuyer") ||
            sameTeam === "Yes" ? (
              <div className="pl-3 pr-3 pb-3">
                This is Multiple Representation. Please ensure Client(s) initial
                consent for multiple representation bubbles on Page 2.
              </div>
            ) : (
              ""
            )}
            {(SellerRep === "OtherExpSeller" || BuyerRep === "OtherExpBuyer") &&
            sameTeam === "No" ? (
              <div className="pl-3 pr-3 pb-3">
                This is NOT Multiple Representation.
                <br />
                <br /> For the purposes of transparency, you should notate the
                Buyer Agents commission in the "additional comments" section
                just below Section #2.
              </div>
            ) : (
              ""
            )}

            {CoCData.map((item, index) => (
              <div key={index} className="pl-5 flex items-center">
                <FontAwesomeIcon
                  icon={faSquareCheck}
                  size="lg"
                  color="#00ad43"
                  className="pr-1 pb-1"
                />
                <li>{item}</li>
              </div>
            ))}
            <div className="pb-4"></div>
          </ul>
        </div>
      </div>
      <div className="CoC-bottom"></div>
    </div>
  );
}
